import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { toast } from "sonner"


interface JoinOrgProps {
  orgId: string;
}

export function JoinOrgButton({ orgId }: JoinOrgProps) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await fetch(`/api/org/${orgId}/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      if (data.error) {
        throw new Error(data.error);
      }
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['publicOrganizations'] });
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      toast.success("Joined organization");
    },
    onError: (error) => {
      toast.error(error.message, {
        style: {
          border: '1px solid #ff4d4f',
          padding: '16px',
          color: '#ff4d4f',
        },
      });
    },
  });

  return (
    <Button
      onClick={() => mutation.mutate()}
      disabled={mutation.isPending}
      variant="default"
      className="w-full mt-2"
    >
      {mutation.isPending ? 'Joining...' : 'Join'}
    </Button>
  );
}
